"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTracker = void 0;
var snowplow = __importStar(require("@snowplow/browser-tracker"));
var js_cookie_1 = __importDefault(require("js-cookie"));
var react_1 = require("react");
var FEATHER_USER_ID_COOKIE = '_fid'; // Cookie set by backend with the user-id upon authentication
function useInterval(callback, delay) {
    var savedCallback = (0, react_1.useRef)();
    // Remember the latest callback.
    (0, react_1.useEffect)(function () {
        savedCallback.current = callback;
    }, [callback]);
    // Set up the interval.
    (0, react_1.useEffect)(function () {
        function tick() {
            var _a;
            (_a = savedCallback.current) === null || _a === void 0 ? void 0 : _a.call(savedCallback);
        }
        if (delay !== null) {
            var id_1 = setInterval(tick, delay);
            return function () { return clearInterval(id_1); };
        }
    }, [delay]);
}
var useTracker = function () {
    var useIdRef = (0, react_1.useRef)();
    var _a = (0, react_1.useState)(undefined), userId = _a[0], setUserId = _a[1];
    useInterval(function () {
        var cookieUserId = js_cookie_1.default.get(FEATHER_USER_ID_COOKIE);
        if (cookieUserId !== useIdRef.current) {
            setUserId(cookieUserId);
            useIdRef.current = cookieUserId;
        }
    }, 3000);
    (0, react_1.useEffect)(function () {
        snowplow.setUserId(userId);
    }, [userId]);
};
exports.useTracker = useTracker;
